<template>
    <div style="padding-top: 1rem;">
        <!-- <div class="top_title fixed">第三方服务共享清单</div> -->
        <div class="content">
            <p>我们服务可能接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</p>

            <p>1、您可利用&ldquo;分享&rdquo;键将某些我们服务内容分享到第三方服务，或您将第三方服务内容分享到我们服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；
            </p>

            <p>2、我们通过我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；</p>

            <p>3、其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：
            </p>

            <p>（1）用于支付相关服务，包括订单支付、交易行为核验、收入结算、支付信息汇总统计等；</p>

            <p>（2）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；</p>

            <p>（3）用于第三方授权服务，包括第三方帐号登陆、将有关内容分享至第三方产品等；</p>

            <p>（4）用于支持产品功能模块，包括在线直播、视频播放、语音识别、AR、智能客服、弹幕播放、内容存储等；</p>

            <p>（5）用于优化产品性能，包括提高硬件配网能力、降低服务器成本、功能热修复等；</p>

            <p>（6）用于帐号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务等。</p>

            <p>我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。
            </p>

            <p>以上第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益并及时与我们取得联系。
            </p>

            <p>我们已接入及根据服务需求将来可能接入的独立第三方列表，以及独立第三方收集的信息、开启的权限和相关的目的，情况如下：</p>

            <p>独立第三方</p>

            <p>我们的产品或服务可能接入第三方插件、链接到第三方网站或者允许您将我们产品或服务的部分内容分享到第三方网站或者应用（上述第三方统称&ldquo;独立第三方&rdquo;）。不同于前文您使用第三方账号登录我们的产品或服务的情况，本条款情形下我们将不会和独立第三方分享您提供给我们的个人信息，但是独立第三方可能单独收集、使用、储存和分享您的个人信息。请您知悉，该等情形下独立第三方对您的个人信息的单独收集、使用、储存和分享行为将适用该独立第三方自己的隐私协议而不是本隐私协议。请您仔细阅读该等隐私协议，如果您对其存在疑问，您可以选择不使用独立第三方提供的服务或者功能。我们将不会为独立第三方对您的个人数据收集、使用、储存和分享行为及其后果承担任何责任。
            </p>

            <p>我们已接入及根据服务需求将来可能接入的独立第三方列表，以及独立第三方收集的信息、开启的权限和相关的目的，情况如下：</p>

            <p>1、支付宝SDK</p>

            <p>所属公司：蚂蚁科技集团股份有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份 (android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：帮助用户在应用内使用支付宝支付，保障网络及运营安全</p>

            <p>官网链接：https://docs.open.alipay.com/</p>

            <p>2、友盟推送SDK</p>

            <p>所属公司：友盟同欣（北京）科技有限公司</p>

            <p>信息读取：SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、MAC地址、IMEI、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：数据统计以及消息推送功能</p>

            <p>官网链接：https://www.umeng.com/</p>

            <p>3、微信SDK</p>

            <p>所属公司：深圳市腾讯计算机系统有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：用于微信账号登录服务、帮助用户分享内容至微信客户端，保障网络及运营安全</p>

            <p>官网链接：https://open.weixin.qq.com/</p>

            <p>4、微信支付SDK</p>

            <p>所属公司：深圳市腾讯计算机系统有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：帮助用户在应用内使用微信支付</p>

            <p>官网链接：https://pay.weixin.qq.com/</p>

            <p>5、QQ SDK</p>

            <p>所属公司：深圳市腾讯计算机系统有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：用于QQ账号登录服务、帮助用户分享内容至QQ客户端，保障网络及运营安全</p>

            <p>官网链接：https://open.tencent.com/</p>

            <p>6、广点通SDK</p>

            <p>所属公司：深圳市腾讯计算机系统有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的。</p>

            <p>官网链接：https://e.qq.com/success/</p>

            <p>7、今日头条广告SDK</p>

            <p>所属公司：北京巨量引擎网络技术有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的。</p>

            <p>官网链接：https://ad.oceanengine.com</p>

            <p>8、UC SDK</p>

            <p>所属公司：广州市动景计算机科技有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的。</p>

            <p>官网链接：https://e.uc.cn/sso/static/pages/hcsso.html</p>

            <p>9、百度SDK</p>

            <p>所属公司：北京百度网讯科技有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的。</p>

            <p>官网链接：http://e.baidu.com/ebaidu/home</p>

            <p>10、快手SDK</p>

            <p>所属公司：北京快手科技有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的。</p>

            <p>官网链接：https://e.kuaishou.com/#/e/home</p>

            <p>11、华为推送SDK</p>

            <p>所属公司：华为软件技术有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：推送消息，保障网络及运营安全</p>

            <p>官网链接：https://developer.huawei.com/consumer/cn/</p>

            <p>12、闪验一键登录SDK</p>

            <p>所属公司：上海创蓝文化传播有限公司</p>

            <p>信息读取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：手机号码一键登录</p>

            <p>官网链接：http://shanyan.253.com/</p>

            <p>13、个推推送SDK</p>

            <p>所属公司：浙江每日互动网络科技股份有限公司</p>

            <p>信息获取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份、访问粗略位置、获取已安装应用程序列表</p>

            <p>使用目的：设备识别码将被用于生成唯一的推送目标ID。设备平台、设备厂商、设备品牌等设备相关信息有助于提供更好的推送服务和体验。为了使用合并链路技术节约您的流量，需要获得应用列表信息。为了实现稳定连续的推送服务，需要了解设备的网络状态信息。为了提供应景推送功能，需要了解您的位置相关信息。
            </p>

            <p>官网链接：http://docs.getui.com/privacy/</p>

            <p>14、华为渠道SDK</p>

            <p>所属公司 ：华为软件技术有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://developer.huawei.com/consumer/cn/</p>

            <p>15、小米渠道SDK</p>

            <p>所属公司 ：小米科技有限责任公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://dev.mi.com/console/</p>

            <p>16、OPPO渠道SDK</p>

            <p>所属公司 ：广东欢太科技有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://open.oppomobile.com/</p>

            <p>17、VIVO渠道SDK</p>

            <p>所属公司 ：维沃通信科技有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://dev.vivo.com.cn/home</p>

            <p>18、九游渠道SDK</p>

            <p>所属公司 ：广州爱九游信息技术有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份 (android.permission.READ_PHONE_STATE)、查找设备上的账号 (android.permission.GET_ACCOUNTS)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://game.open.uc.cn/</p>

            <p>19、应用宝渠道SDK</p>

            <p>所属公司 ：深圳市腾讯计算机系统有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：https://open.tencent.com/</p>

            <p>20、百度渠道SDK</p>

            <p>所属公司 ：北京百度网讯科技有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份（android.permission.READ_PHONE_STATE）</p>

            <p>使用目的：用户的账号登录信息存储、保障服务的正常运行和安全风控</p>

            <p>官网链接：http://app.baidu.com/</p>

            <p>21、奇虎360渠道SDK</p>

            <p>所属公司 ：北京奇虎科技有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份（android.permission.READ_PHONE_STATE）、查找设备上的账号 (android.permission.GET_ACCOUNTS)</p>

            <p>使用目的：用户的账号登录信息存储、保障服务的正常运行和安全风控</p>

            <p>官网链接：http://dev.360.cn/</p>

            <p>22、魅族渠道SDK</p>

            <p>所属公司 ：珠海市魅族通讯设备有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份 (android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：http://open.flyme.cn/</p>

            <p>23、联想渠道SDK</p>

            <p>所属公司 ：北京联想调频科技有限公司</p>

            <p>信息获取：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份（android.permission.READ_PHONE_STATE）、查找设备上的账号
                (android.permission.GET_ACCOUNTS)、读取短信信息（android.permission.READ_SMS）、发送短信信息（android.permission.SEND_SMS）
            </p>

            <p>使用目的：识别渠道用户，保障网络及运营安全，手机登录自动发送验证短信，自动读取手机验证码</p>

            <p>官网链接：http://open.lenovomm.com/developer/</p>

            <p>24、阿里旺旺</p>

            <p>所属公司 ：阿里巴巴（中国）网络技术有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：/</p>

            <p>使用目的：识别渠道用户，展示商品或服务信息及保障网络及运营安全</p>

            <p>官网链接：https://wangwang.taobao.com</p>

            <p>25、阿里云API</p>

            <p>所属公司 ：阿里巴巴（中国）网络技术有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：/</p>

            <p>使用目的：保障网络及运营安全</p>

            <p>官网链接：https://www.aliyun.com</p>

            <p>26、Unity 3D SDK</p>

            <p>所属公司 ：Unity Technologies</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取外置存储器</p>

            <p>使用目的：性能分析</p>

            <p>官网链接：https://unity3d.com/legal/privacy-policy</p>

            <p>27、厦门微讯 SDK</p>

            <p>所属公司 ：厦门微讯信息科技有限公司</p>

            <p>信息获取
                ：设备品牌、型号、软件系统版本相关信息、oaid、设备IMEI、AndroidID、MEID、硬件序列号、系统属性、操作系统等基础信息、无线网SSID名称、WIFI路由器MAC地址、设备的mac地址、IMSI、ICCID、WIFI状态
            </p>

            <p>权限获取：读取手机状态和身份(android.permission.READ_PHONE_STATE)</p>

            <p>使用目的：数据统计以及识别渠道用户，保障网络及运营安全</p>

            <p>官网链接：http://www.rvfdp.com</p>

        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
    }
</script>
<style lang="less" scoped>
    .content {
        padding: 1rem 0;
    }

    p {
        font-size: 14px;
        text-indent: 2em;
    }
</style>